<template>
  <rest-list-filter-input
    :prop="prop"
    :readonly="readonly"
    icon="el-icon-arrow-right"
    :default-value="defaultValue"
  />
</template>

<script>
import RestListFilterInput from '@/common/components/rest/RestListFilterInput'

export default {
  name: 'RestListFilterNumber',
  components: { RestListFilterInput },

  props: {
    prop: {
      type: String,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    },

    defaultValue: {
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListFilterNumber.vue